import { render } from "./navigation_back_button.html?vue&type=template&id=193f5621&external"
import script from "./navigation_back_button.js?vue&type=script&lang=js&external"
export * from "./navigation_back_button.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__